export const env = {
    apiUrl: process.env.REACT_APP_API_URL || '/api/v1',
    production: process.env.REACT_APP_PRODUCTION === 'true' || false,
    ssoUrl: process.env.REACT_APP_SSO_URL || 'https://sso.gymoo.it',
    reactAppSocketUrl: process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001'
};
